let questionnaireMessages = {
  en: {
    buttonText: {
      allDone: 'All Done',
      ok: 'OK',
      noneOfTheAbove: 'None of the above'
    },
    helperText: {
      freeTextPlaceholder: 'Please type answer here',
      multipleChoiceHintText: 'Choose as many as you like',
      multipleChoiceMinText: 'Please choose at least ',
      multipleChoiceMaxText: 'Please choose up to ',
      multipleChoiceMinMaxTextPartOne: 'Please choose between ',
      multipleChoiceMinMaxTextPartTwo: 'to',
      multipleChoiceExactText: 'Choose only ',

      opinionScaleDefaultMin: 'Completely Disagree',
      opinionScaleDefaultMax: 'Completely Agree',

      thankYouTextPartOne: 'Thank you!',
      thankYouTextPartTwo: 'Your answers were sent perfectly!'

    },
    errorMessages: {
      multipleChoiceMinText: 'Please choose at least ',
      multipleChoiceMaxText: 'Please choose up to ',
      multipleChoiceMinMaxTextPartOne: 'Please choose between ',
      multipleChoiceMinMaxTextPartTwo: 'to',
      multipleChoiceExactText: 'Please choose only ',
      multipleChoiceOptions: 'options',

      numberMaxText: 'Please enter a number less than ',
      numberMinText: 'Please enter a number more than ',

      genericRequired: 'Please answer this question.',
      dateOutOfRange: 'Please choose a valid date within the time range.',
      invalidDate: 'Please choose a valid date.',
      invalidQuestionId: 'Sorry! Something is wrong with this form. Please contact jenny@healint.com'
    }

  },
  de: {

  },
  fr: {

  }
}

export { questionnaireMessages }



// WEBPACK FOOTER //
// ./src/store/localization/questionnaireLocalizationStrings.js